<template>
  <v-container fill-height v-if="!loadingPersonal">
    <v-row align="center" justify="center" v-if="personalCompleto">
      <v-col cols="9" align="left" justify="center">
        <div class="font-weight-bold">Información del personal</div>

        <v-container>
          <v-row align="center">
            <v-col cols="12" class="pb-0" align="center">
              <v-avatar rounded color="secondary" size="80" v-if="!personalCompleto.foto">
                <v-icon x-large color="primary">mdi-account</v-icon>
              </v-avatar>
              <v-img
                v-else
                :src="personalCompleto.foto"
                max-height="80"
                max-width="80"
                @error="personalCompleto.foto = null"
              ></v-img>
            </v-col>
            <v-col cols="12" align="center" class="pb-0">
              <div class="text-subtitle-1 text--primary">
                {{ getFullName(personalCompleto) }}
              </div>
            </v-col>
            <v-col cols="12" class="pt-2">
              <v-expansion-panels class="asistencia-panels" accordion>
                <v-expansion-panel class="asistencia-panel">
                  <v-expansion-panel-header class="asistencia-panel-header">
                    <span>Datos generales</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" align="left" class="pb-0">
                        <div class="text-caption mb-1">CUIP</div>
                        <div class="text-body-1 text--primary">{{ personalCompleto.CUIP || 'Sin datos' }}</div>
                      </v-col>
                      <v-col cols="12" align="left" class="pb-0">
                        <div class="text-caption mb-1">CURP</div>
                        <div class="text-body-1 text--primary">{{ personalCompleto.curp || 'Sin datos' }}</div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="asistencia-panel">
                  <v-expansion-panel-header class="asistencia-panel-header">
                    <span>Contacto</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" align="left" class="pb-0">
                        <div class="text-caption mb-1">Teléfono celular</div>
                        <div class="text-body-1 text--primary">
                          {{ personalCompleto.Contacto?.telefonoCelular || 'Sin datos' }}
                        </div>
                      </v-col>
                      <v-col cols="12" align="left" class="pb-0">
                        <div class="text-caption mb-1">Teléfono fijo</div>
                        <div class="text-body-1 text--primary">
                          {{ personalCompleto.Contacto?.telefonoFijo || 'Sin datos' }}
                        </div>
                      </v-col>
                      <v-col cols="12" align="left" class="pb-0">
                        <div class="text-caption mb-1">E-mail</div>
                        <div class="text-body-1 text--primary">
                          {{ personalCompleto.Contacto?.correoElectronico || 'Sin datos' }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="asistencia-panel">
                  <v-expansion-panel-header class="asistencia-panel-header">
                    <span>Registro de asistencia</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" class="pb-0 mt-4" align="left">
                        <v-select
                          class="modern-input"
                          v-model="asistencia"
                          :items="tiposAsistencia"
                          item-value="id"
                          item-text="title"
                          item-color="secondary"
                          label="Tipo de asistencia"
                          filled
                          rounded
                          dense
                          color="secondary"
                          background-color="primary"
                        />
                      </v-col>
                      <v-col cols="12" class="pb-0" align="left">
                        <v-select
                          class="modern-input"
                          v-model="servicio"
                          :items="serviciosCatalogo"
                          item-value="id"
                          item-text="title"
                          item-color="secondary"
                          label="Servicio"
                          filled
                          rounded
                          dense
                          color="secondary"
                          background-color="primary"
                        />
                      </v-col>
                      <v-col cols="12" class="pb-0" sm="6" align="left">
                        <v-text-field
                          class="modern-input"
                          v-model="crpUnidad"
                          label="CRP / Unidad"
                          filled
                          rounded
                          dense
                          color="secondary"
                          background-color="primary"
                        />
                      </v-col>
                      <v-col cols="12" class="pb-0" sm="6" align="left">
                        <v-text-field
                          class="modern-input"
                          v-model="radio"
                          label="Radio"
                          filled
                          rounded
                          dense
                          color="secondary"
                          background-color="primary"
                        />
                      </v-col>
                      <v-col cols="12" class="pb-0" sm="6" align="left">
                        <v-text-field
                          class="modern-input"
                          v-model="sector"
                          label="Sector"
                          filled
                          rounded
                          dense
                          color="secondary"
                          background-color="primary"
                        />
                      </v-col>
                      <v-col v-if="allowDateSelection" cols="12" class="pb-0" sm="6" align="left">
                        <v-menu
                          v-model="menuFecha"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="modern-input"
                              :value="fechaDisplayValue"
                              label="Fecha"
                              readonly
                              filled
                              rounded
                              dense
                              color="secondary"
                              background-color="primary"
                              append-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            class="modern-date-picker"
                            v-model="fecha"
                            :max="hoy"
                            locale="es"
                            color="secondary"
                            no-title
                            @input="menuFecha = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="pb-0" sm="6" align="left">
                        <v-text-field
                          class="modern-input"
                          v-model="hora"
                          v-mask="'##:##'"
                          label="Hora"
                          placeholder="00:00"
                          persistent-placeholder
                          maxlength="5"
                          filled
                          rounded
                          dense
                          color="secondary"
                          background-color="primary"
                          append-icon="mdi-clock-outline"
                          :error-messages="horaError"
                          @blur="validarHora"
                        />
                      </v-col>
                      <v-col cols="12" class="pb-0 mb-1" align="center">
                        <TextButton
                          rounded
                          color="secondary"
                          @click="guardarAsistencia"
                          :loading="loading"
                          :disabled="!asistencia || loading"
                        >
                          Guardar cambios
                        </TextButton>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" v-else>
      <v-col cols="12" align="center">
        <div class="text-subtitle-1 text--primary">No se pudo cargar la información del personal</div>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <v-progress-circular indeterminate color="secondary"></v-progress-circular>
        <div class="text-subtitle-1 text--primary mt-4">Cargando información...</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'
import BaseSelect from '@/components/base/BaseSelect.vue'
import BaseInput from '@/components/base/BaseInput.vue'

export default {
  components: {
    TextButton,
    BaseSelect,
    BaseInput,
  },
  props: {
    selectedPersonal: {
      type: Object,
      required: false,
      default: null,
    },
    allowDateSelection: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      asistencia: null,
      servicio: null,
      crpUnidad: '',
      radio: '',
      sector: '',
      hora: '',
      horaError: '',
      fecha: moment().format('YYYY-MM-DD'),
      menuFecha: false,
      loading: false,
      loadingTipos: false,
      loadingPersonal: false,
      personalCompleto: null,
    }
  },

  watch: {
    hora(val) {
      if (!val) this.horaError = ''
    },
  },

  computed: {
    ...mapGetters('asistencia', {
      tiposAsistencia: 'getTiposAsistencia',
      serviciosCatalogo: 'getTiposServicio',
    }),
    hoy() {
      return moment().format('YYYY-MM-DD')
    },
    fechaDisplayValue() {
      return this.fecha ? moment(this.fecha, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
    },
  },

  async mounted() {
    await Promise.all([this.fetchTiposAsistencia(), this.fetchTiposServicio(), this.fetchPersonalCompleto()])
  },

  methods: {
    ...mapActions('asistencia', [
      'fetchTipoAsistencia',
      'fetchTipoServicio',
      'saveAsistencia',
      'verificarAsistenciaHoy',
    ]),
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async fetchTiposAsistencia() {
      try {
        this.loadingTipos = true
        await this.fetchTipoAsistencia()
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al cargar los tipos de asistencia.')
      } finally {
        this.loadingTipos = false
      }
    },

    async fetchTiposServicio() {
      try {
        await this.fetchTipoServicio()
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al cargar el catálogo de servicios.')
      }
    },

    async fetchPersonalCompleto() {
      if (!this.selectedPersonal) return

      try {
        this.loadingPersonal = true
        const idPersonal = this.selectedPersonal.idPersonal || this.selectedPersonal.id_personal

        await this.fetchPersonalById(idPersonal)

        this.personalCompleto = this.$store.getters['personal/getPersonalSingle']
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al cargar la información del personal.')
        this.personalCompleto = null
      } finally {
        this.loadingPersonal = false
      }
    },

    getFullName(person) {
      if (!person) return 'Sin nombre'

      const nombre = person.nombre || ''
      const segundoNombre = person.segundoNombre || ''
      const apaterno = person.apaterno || ''
      const amaterno = person.amaterno || ''

      return `${apaterno} ${amaterno} ${nombre} ${segundoNombre}`.trim()
    },

    validarHora() {
      if (!this.hora || this.hora.length < 5) {
        this.horaError = ''
        return
      }
      const [hh, mm] = this.hora.split(':').map(Number)
      if (hh > 23 || mm > 59) {
        this.horaError = 'Hora inválida (00:00 – 23:59)'
      } else {
        this.horaError = ''
      }
    },

    async guardarAsistencia() {
      if (!this.asistencia) {
        this.SET_SNACKBAR_MESSAGE('Por favor selecciona un tipo de asistencia.')
        return
      }

      if (this.hora && !moment(this.hora, 'HH:mm', true).isValid()) {
        this.SET_SNACKBAR_MESSAGE('Ingresa una hora válida con formato HH:mm.')
        return
      }

      try {
        this.loading = true

        const personalId = this.selectedPersonal.idPersonal || this.selectedPersonal.id_personal

        const fechaBase = this.allowDateSelection
          ? moment(this.fecha, 'YYYY-MM-DD').format('YYYY/MM/DD')
          : moment().format('YYYY/MM/DD')

        const esHoy = fechaBase === moment().format('YYYY/MM/DD')
        if (esHoy) {
          const tieneAsistenciaHoy = await this.verificarAsistenciaHoy(personalId)
          if (tieneAsistenciaHoy) {
            this.SET_SNACKBAR_MESSAGE('Ya se registró asistencia para este personal el día de hoy.')
            this.loading = false
            return
          }
        }
        const hora = this.hora || moment().format('HH:mm')
        const crpUnidadValue = this.crpUnidad ? this.crpUnidad.trim() : ''

        const payload = {
          fk_idPersonal: personalId,
          fk_idTipoAsistencia: this.asistencia,
          fecha: `${fechaBase} ${hora}`,
          fk_idTipoServio: this.servicio || null,
          fk_idTipoServicio: this.servicio || null,
          crp: crpUnidadValue || null,
          crpUnidad: crpUnidadValue || null,
          radio: this.radio || null,
          sector: this.sector || null,
        }

        await this.saveAsistencia({
          idPersonal: payload.fk_idPersonal,
          asistencia: payload,
        })

        this.$emit('close')
        this.asistencia = null
        this.servicio = null
        this.crpUnidad = ''
        this.radio = ''
        this.sector = ''
        this.hora = ''
        this.horaError = ''
        this.fecha = moment().format('YYYY-MM-DD')
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al guardar la asistencia.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.asistencia-panels {
  background: transparent;
}
.asistencia-panel {
  margin-bottom: 8px;
  border-radius: 10px !important;
  overflow: hidden;
  box-shadow:
    4px 4px 8px var(--v-primary-darken2),
    -4px -4px 8px var(--v-primary-lighten1) !important;
}
.asistencia-panel-header {
  font-weight: 600;
  min-height: 48px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

::v-deep .modern-input .v-input__slot {
  background: rgba(8, 14, 19, 0.5) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.2) !important;
  border-radius: 12px !important;
}

::v-deep .modern-input .v-label,
::v-deep .modern-input input,
::v-deep .modern-input .v-icon {
  color: #e0f0ff !important;
}

::v-deep .modern-input.v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.15) !important;
}

::v-deep .modern-date-picker {
  border: 1px solid rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.24) !important;
  border-radius: 14px;
  overflow: hidden;
  background: rgba(7, 12, 18, 0.86) !important;
}

::v-deep .modern-date-picker .v-date-picker-header,
::v-deep .modern-date-picker .v-date-picker-table,
::v-deep .modern-date-picker .v-picker__body {
  background: transparent !important;
}

::v-deep .modern-date-picker .v-btn {
  color: #d9ebff !important;
}
</style>
